module.exports = __webpack_public_path__ + "static/img/M-4.61ae49f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/myixuekao/M-4.png
// module id = BCK1
// module chunks = 0